@if(open){
  <div class="rms-prompt-backdrop" (click)="cancel()">
    <div class="rms-prompt-container" (click)="$event.stopPropagation()">

      <h3 style="margin:0 0 12px;">{{ options.title || 'Compose Email' }}</h3>

      <!-- FROM -->
      <!--<mat-form-field style="width:100%;">
    <mat-label>From</mat-label>
    <mat-select [formControl]="form.controls.from">
      @for (f of (options?.fromOptions || []); track $index) {
        <mat-option [value]="f">{{ f }}</mat-option>
      }
    </mat-select>
  </mat-form-field>-->
      <mat-form-field style="width:100%;">
        <mat-label>From</mat-label>
        <input matInput [formControl]="form.controls.from" [disabled]="true">
      </mat-form-field>
      <!-- TO / CC / BCC chips -->
      <mat-form-field style="width:100%;">
        <mat-label>To</mat-label>
        <mat-chip-grid #toGrid [formControl]="form.controls.to">
          @for (e of form.controls.to.value; track $index) {
          <mat-chip-row (removed)="removeChip('to', e)">
            {{e}} <button matChipRemove aria-label="Remove"><mat-icon>cancel</mat-icon></button>
          </mat-chip-row>
          }
          <input matInput placeholder="Add recipient (Enter To Save)"
                 [matChipInputFor]="toGrid"
                 [matChipInputSeparatorKeyCodes]="separatorKeys"
                 [matChipInputAddOnBlur]="true"
                 (matChipInputTokenEnd)="addChip('to', $event)">
        </mat-chip-grid>
      </mat-form-field>

      <mat-form-field style="width:100%;">
        <mat-label>CC</mat-label>
        <mat-chip-grid #ccGrid [formControl]="form.controls.cc">
          @for (e of form.controls.cc.value; track $index) {
          <mat-chip-row (removed)="removeChip('cc', e)">
            {{e}} <button matChipRemove><mat-icon>cancel</mat-icon></button>
          </mat-chip-row>
          }
          <input matInput placeholder="Add CC (Enter To Save)"
                 [matChipInputFor]="ccGrid"
                 [matChipInputSeparatorKeyCodes]="separatorKeys"
                 [matChipInputAddOnBlur]="true"
                 (matChipInputTokenEnd)="addChip('cc', $event)">
        </mat-chip-grid>
      </mat-form-field>

      <div style="display:flex; gap:30px">
        <mat-form-field style="width:100%;">
          <mat-label>Subject</mat-label>
          <input matInput [formControl]="form.controls.subject">
        </mat-form-field>
        <!-- ✅ Attachments -->
      </div>

      <!-- HTML body -->
      <div style="display:flex; gap:10px">
        <div style="margin-top: 10px;">
          <div style="font-size:12px; opacity:.7; margin-bottom:6px;">Attachments</div>


          <div style="display:flex; gap:8px; flex-wrap:wrap; margin-bottom:10px; font-size:12px">
            @for(a of attachments; track $index){
            <div style="border: 1px solid #ddd; border-radius: 8px; padding: 6px 10px; display: flex; gap: 10px; align-items: center; height: 30px;">
              <span>{{a.fileName}}</span>
              <button mat-icon-button color="warn" (click)="removeAttachment($index)">
                <mat-icon>close</mat-icon>
              </button>
            </div>
            }
          </div>


          @if(options.allowAddAttachments !== false){
          <input type="file" multiple (change)="onPickFiles($event)" />
          }
        </div>
        <div style="display:flex; gap:10px; flex-direction:column; width:50%">
          <mat-form-field>
            <mat-label>Salutation</mat-label>
            <input matInput [formControl]="form.controls.salutation" placeholder="Dear" />
          </mat-form-field>

          <mat-form-field>
            <mat-label>Dear Name</mat-label>
            <input matInput [formControl]="form.controls.dearName" placeholder="Dear..." />
          </mat-form-field>

          <mat-form-field>
            <mat-label>Optional Text (adds a separate paragraph)</mat-label>
            <textarea matInput rows="3" [formControl]="form.controls.optionalText"></textarea>
          </mat-form-field>
        </div>
        <!-- preview (optional) -->
        <div class="preview-box">
          <div style="font-size:12px; opacity:.7; margin-bottom:8px;">Preview</div>
          <div [innerHTML]="form.controls.html.value"></div>
        </div>
      </div>

      <div class="rms-prompt-actions">
        <button mat-surface-button class="btn-bg-red" (click)="cancel()">Cancel</button>
        <button mat-surface-button class="btn-bg-green" (click)="submit()" [disabled]="form.invalid">Send</button>
      </div>

    </div>
  </div>
}
